module.exports = __webpack_public_path__ + "img/azxy20_icon.f6631adb.png";